 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~b6592a7c":"layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~b6592a7c","layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~cc6430bb":"layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~cc6430bb","layouts-base-Index~layouts-default-Index":"layouts-base-Index~layouts-default-Index","layouts-base-Index":"layouts-base-Index","layouts-default-Index~views-atendimento-Index~views-atendimento-bkp-Index~views-filtro-food-Index~vi~1efb64e5":"layouts-default-Index~views-atendimento-Index~views-atendimento-bkp-Index~views-filtro-food-Index~vi~1efb64e5","layouts-default-Index":"layouts-default-Index","views-filtro-food-Index~views-filtro-food-bkp-Index~views-valor-food-Index":"views-filtro-food-Index~views-filtro-food-bkp-Index~views-valor-food-Index","views-filtro-food-Index":"views-filtro-food-Index","views-valor-food-Index":"views-valor-food-Index","views-produto-Index~views-produto-food-bkp-Index~views-sign-in-Index":"views-produto-Index~views-produto-food-bkp-Index~views-sign-in-Index","views-produto-Index":"views-produto-Index","views-produto-food-bkp-Index":"views-produto-food-bkp-Index","views-sign-in-Index":"views-sign-in-Index","views-atendimento-AppBar~views-atendimento-Index~views-atendimento-bkp-AppBar~views-atendimento-bkp-~2375fd3a":"views-atendimento-AppBar~views-atendimento-Index~views-atendimento-bkp-AppBar~views-atendimento-bkp-~2375fd3a","views-atendimento-Index":"views-atendimento-Index","views-atendimento-bkp-Index":"views-atendimento-bkp-Index","views-atendimento-AppBar~views-atendimento-bkp-AppBar~views-camera_barcode-AppBar~views-filtro-food-~d786bf92":"views-atendimento-AppBar~views-atendimento-bkp-AppBar~views-camera_barcode-AppBar~views-filtro-food-~d786bf92","views-atendimento-AppBar":"views-atendimento-AppBar","views-atendimento-bkp-AppBar":"views-atendimento-bkp-AppBar","views-camera_barcode-AppBar":"views-camera_barcode-AppBar","views-filtro-food-AppBar":"views-filtro-food-AppBar","views-filtro-food-bkp-AppBar":"views-filtro-food-bkp-AppBar","views-home-AppBar":"views-home-AppBar","views-produto-AppBar":"views-produto-AppBar","views-produto-food-AppBar":"views-produto-food-AppBar","views-produto-food-bkp-AppBar":"views-produto-food-bkp-AppBar","views-valor-food-AppBar":"views-valor-food-AppBar","views-filtro-food-bkp-Index":"views-filtro-food-bkp-Index","views-produto-food-Index":"views-produto-food-Index","views-camera_barcode-Index":"views-camera_barcode-Index","views-home-Index":"views-home-Index"}[chunkId]||chunkId) + "." + {"layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~b6592a7c":"bcf05f3d","layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~cc6430bb":"4a0191de","layouts-base-Index~layouts-default-Index":"c09ac5ad","layouts-base-Index":"f304cec4","layouts-default-Index~views-atendimento-Index~views-atendimento-bkp-Index~views-filtro-food-Index~vi~1efb64e5":"a1b0e3a4","layouts-default-Index":"7ea699a8","views-filtro-food-Index~views-filtro-food-bkp-Index~views-valor-food-Index":"0be99de2","views-filtro-food-Index":"b39f9d46","views-valor-food-Index":"bf685222","views-produto-Index~views-produto-food-bkp-Index~views-sign-in-Index":"2e7f8297","views-produto-Index":"bc189973","views-produto-food-bkp-Index":"a5320dbc","views-sign-in-Index":"d6901eee","views-atendimento-AppBar~views-atendimento-Index~views-atendimento-bkp-AppBar~views-atendimento-bkp-~2375fd3a":"91441c13","views-atendimento-Index":"c0d83aa5","views-atendimento-bkp-Index":"67589931","views-atendimento-AppBar~views-atendimento-bkp-AppBar~views-camera_barcode-AppBar~views-filtro-food-~d786bf92":"2cf90198","views-atendimento-AppBar":"a156c385","views-atendimento-bkp-AppBar":"f92aab7f","views-camera_barcode-AppBar":"7bc8ae05","views-filtro-food-AppBar":"2f071c9e","views-filtro-food-bkp-AppBar":"0bfc5417","views-home-AppBar":"2c3833d9","views-produto-AppBar":"fc7305b1","views-produto-food-AppBar":"a5907a8e","views-produto-food-bkp-AppBar":"5ceace47","views-valor-food-AppBar":"4df9ba03","views-filtro-food-bkp-Index":"bed36364","views-produto-food-Index":"9eddb515","views-camera_barcode-Index":"9f751555","views-home-Index":"cc7e8486"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~b6592a7c":1,"layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~cc6430bb":1,"layouts-base-Index~layouts-default-Index":1,"layouts-base-Index":1,"layouts-default-Index~views-atendimento-Index~views-atendimento-bkp-Index~views-filtro-food-Index~vi~1efb64e5":1,"layouts-default-Index":1,"views-filtro-food-Index~views-filtro-food-bkp-Index~views-valor-food-Index":1,"views-filtro-food-Index":1,"views-valor-food-Index":1,"views-produto-Index~views-produto-food-bkp-Index~views-sign-in-Index":1,"views-produto-Index":1,"views-produto-food-bkp-Index":1,"views-sign-in-Index":1,"views-atendimento-AppBar~views-atendimento-Index~views-atendimento-bkp-AppBar~views-atendimento-bkp-~2375fd3a":1,"views-atendimento-Index":1,"views-atendimento-bkp-Index":1,"views-atendimento-AppBar~views-atendimento-bkp-AppBar~views-camera_barcode-AppBar~views-filtro-food-~d786bf92":1,"views-camera_barcode-AppBar":1,"views-filtro-food-AppBar":1,"views-produto-food-AppBar":1,"views-produto-food-bkp-AppBar":1,"views-filtro-food-bkp-Index":1,"views-produto-food-Index":1,"views-camera_barcode-Index":1,"views-home-Index":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~b6592a7c":"layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~b6592a7c","layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~cc6430bb":"layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~cc6430bb","layouts-base-Index~layouts-default-Index":"layouts-base-Index~layouts-default-Index","layouts-base-Index":"layouts-base-Index","layouts-default-Index~views-atendimento-Index~views-atendimento-bkp-Index~views-filtro-food-Index~vi~1efb64e5":"layouts-default-Index~views-atendimento-Index~views-atendimento-bkp-Index~views-filtro-food-Index~vi~1efb64e5","layouts-default-Index":"layouts-default-Index","views-filtro-food-Index~views-filtro-food-bkp-Index~views-valor-food-Index":"views-filtro-food-Index~views-filtro-food-bkp-Index~views-valor-food-Index","views-filtro-food-Index":"views-filtro-food-Index","views-valor-food-Index":"views-valor-food-Index","views-produto-Index~views-produto-food-bkp-Index~views-sign-in-Index":"views-produto-Index~views-produto-food-bkp-Index~views-sign-in-Index","views-produto-Index":"views-produto-Index","views-produto-food-bkp-Index":"views-produto-food-bkp-Index","views-sign-in-Index":"views-sign-in-Index","views-atendimento-AppBar~views-atendimento-Index~views-atendimento-bkp-AppBar~views-atendimento-bkp-~2375fd3a":"views-atendimento-AppBar~views-atendimento-Index~views-atendimento-bkp-AppBar~views-atendimento-bkp-~2375fd3a","views-atendimento-Index":"views-atendimento-Index","views-atendimento-bkp-Index":"views-atendimento-bkp-Index","views-atendimento-AppBar~views-atendimento-bkp-AppBar~views-camera_barcode-AppBar~views-filtro-food-~d786bf92":"views-atendimento-AppBar~views-atendimento-bkp-AppBar~views-camera_barcode-AppBar~views-filtro-food-~d786bf92","views-atendimento-AppBar":"views-atendimento-AppBar","views-atendimento-bkp-AppBar":"views-atendimento-bkp-AppBar","views-camera_barcode-AppBar":"views-camera_barcode-AppBar","views-filtro-food-AppBar":"views-filtro-food-AppBar","views-filtro-food-bkp-AppBar":"views-filtro-food-bkp-AppBar","views-home-AppBar":"views-home-AppBar","views-produto-AppBar":"views-produto-AppBar","views-produto-food-AppBar":"views-produto-food-AppBar","views-produto-food-bkp-AppBar":"views-produto-food-bkp-AppBar","views-valor-food-AppBar":"views-valor-food-AppBar","views-filtro-food-bkp-Index":"views-filtro-food-bkp-Index","views-produto-food-Index":"views-produto-food-Index","views-camera_barcode-Index":"views-camera_barcode-Index","views-home-Index":"views-home-Index"}[chunkId]||chunkId) + "." + {"layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~b6592a7c":"b08fe28c","layouts-base-Index~layouts-default-Index~views-atendimento-AppBar~views-atendimento-Index~views-aten~cc6430bb":"3d5d6e8d","layouts-base-Index~layouts-default-Index":"696c27b3","layouts-base-Index":"487f8d50","layouts-default-Index~views-atendimento-Index~views-atendimento-bkp-Index~views-filtro-food-Index~vi~1efb64e5":"2ffa506b","layouts-default-Index":"890784cd","views-filtro-food-Index~views-filtro-food-bkp-Index~views-valor-food-Index":"b2e17ca9","views-filtro-food-Index":"3d2173a0","views-valor-food-Index":"7634d2f6","views-produto-Index~views-produto-food-bkp-Index~views-sign-in-Index":"3c92fb0b","views-produto-Index":"f0115be1","views-produto-food-bkp-Index":"0d16940e","views-sign-in-Index":"0d882293","views-atendimento-AppBar~views-atendimento-Index~views-atendimento-bkp-AppBar~views-atendimento-bkp-~2375fd3a":"e29a1954","views-atendimento-Index":"da00f693","views-atendimento-bkp-Index":"f9c2e5cd","views-atendimento-AppBar~views-atendimento-bkp-AppBar~views-camera_barcode-AppBar~views-filtro-food-~d786bf92":"85e62623","views-atendimento-AppBar":"31d6cfe0","views-atendimento-bkp-AppBar":"31d6cfe0","views-camera_barcode-AppBar":"ef130c28","views-filtro-food-AppBar":"5fa35585","views-filtro-food-bkp-AppBar":"31d6cfe0","views-home-AppBar":"31d6cfe0","views-produto-AppBar":"31d6cfe0","views-produto-food-AppBar":"95263c98","views-produto-food-bkp-AppBar":"33094e15","views-valor-food-AppBar":"31d6cfe0","views-filtro-food-bkp-Index":"60906341","views-produto-food-Index":"ace0f055","views-camera_barcode-Index":"fa33ac07","views-home-Index":"9e9903c9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
